export const updatesData = [
  {
    id: 1,
    date: '2026-07-30',
    time: '14:32',
    title: '台北娜娜最新直播爆料：某顶流男星深夜约会神秘女子',
    tag: '独家',
    summary: '据知情人士透露，该男星近期频繁出入台北某高档餐厅，与一名年轻女性举止亲密，引发粉丝热议。',
  },
  {
    id: 2,
    date: '2026-07-29',
    time: '21:15',
    title: '51吃瓜大赛第三季火热进行中，围观群众突破百万',
    tag: '热门',
    summary: '本季大赛新增暗网吃瓜环节，参赛选手需在规定时间内挖掘最劲爆的八卦线索，战况激烈。',
  },
  {
    id: 3,
    date: '2026-07-29',
    time: '16:48',
    title: '某知名网红被曝私下人设崩塌，聊天记录流出',
    tag: '爆料',
    summary: '多张私密对话截图在社区疯传，当事人尚未回应，网友纷纷站队讨论。',
  },
  {
    id: 4,
    date: '2026-07-28',
    time: '11:20',
    title: '暗网吃瓜新线索：娱乐圈幕后资本大洗牌',
    tag: '深度',
    summary: '多家娱乐公司股权变动背后疑似涉及对赌协议，多位艺人合约到期面临站队选择。',
  },
  {
    id: 5,
    date: '2026-07-28',
    time: '09:05',
    title: '吃瓜讨论区今日热议：综艺节目剧本门再升级',
    tag: '热议',
    summary: '某热门综艺导演被曝操控比赛结果，参与者公开质疑节目公正性，引发行业震荡。',
  },
  {
    id: 6,
    date: '2026-07-27',
    time: '18:30',
    title: '51吃瓜台北站前线报道：明星夜市偶遇大合集',
    tag: '现场',
    summary: '多位艺人被目击在台北各大夜市现身，从穿着到互动细节全记录。',
  },
  {
    id: 7,
    date: '2026-07-27',
    time: '10:00',
    title: '八卦社区周报：本周最受关注的十大吃瓜事件盘点',
    tag: '盘点',
    summary: '从恋情曝光到合约纠纷，本周吃瓜群众最关心的热点事件全在这里。',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '51吃瓜大赛：全民围观的八卦盛宴',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20crowd%20gathered%20around%20a%20glowing%20stage%20with%20spotlight%2C%20warm%20orange%20and%20coral%20gradient%20background%2C%20stylized%20silhouettes%2C%20dramatic%20lighting%2C%20entertainment%20event%20atmosphere%2C%20modern%20minimalist%20style%20with%20geometric%20shapes%2C%20clean%20composition%2C%20professional%20design&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '火热进行中',
    desc: '百万吃瓜群众齐聚，谁能问鼎八卦之王？',
  },
  {
    id: 2,
    title: '暗网吃瓜专区：独家深度爆料',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20composition%20with%20warm%20amber%20glowing%20lines%20on%20dark%20background%2C%20hidden%20information%20concept%2C%20stylized%20data%20streams%2C%20warm%20golden%20accents%2C%20modern%20digital%20art%2C%20geometric%20patterns%2C%20intrigue%20and%20mystery%20theme%2C%20clean%20professional%20design&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '独家内容',
    desc: '揭秘那些不为人知的圈内真相。',
  },
  {
    id: 3,
    title: '台北娜娜专栏：前线吃瓜第一手',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20cityscape%20at%20dusk%20with%20neon%20glow%2C%20stylized%20urban%20night%20scene%2C%20coral%20and%20amber%20highlights%2C%20Taipei-inspired%20silhouette%2C%20modern%20artistic%20style%2C%20soft%20gradients%2C%20trending%20entertainment%20atmosphere%2C%20clean%20geometric%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '前线报道',
    desc: '台北站记者娜娜为你带来最鲜活的八卦资讯。',
  },
  {
    id: 4,
    title: '八卦讨论区：全民参与互动',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20connected%20social%20network%20nodes%20with%20warm%20orange%20glowing%20connections%2C%20community%20discussion%20concept%2C%20stylized%20bubbles%20and%20links%2C%20coral%20and%20amber%20palette%2C%20modern%20minimalist%20design%2C%20engaging%20visual%20with%20depth%2C%20clean%20professional%20layout&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '热门讨论',
    desc: '加入讨论区，和百万吃瓜群众一起聊八卦。',
  },
  {
    id: 5,
    title: '热门事件追踪：实时更新中',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20timeline%20visualization%20with%20warm%20pulsing%20nodes%2C%20real-time%20tracking%20concept%2C%20coral%20and%20amber%20energy%20waves%2C%20stylized%20notification%20stream%2C%20modern%20data%20aesthetic%2C%20entertainment%20news%20theme%2C%20clean%20geometric%20shapes%2C%20professional%20design&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '实时追踪',
    desc: '热点事件持续更新，不错过任何一个瓜。',
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20young%20person%20with%20warm%20coral%20and%20cream%20tones%2C%20minimalist%20profile%2C%20soft%20gradients%2C%20modern%20illustration%20style%2C%20clean%20background%2C%20simple%20geometric%20shapes&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '吃瓜第一线',
    time: '2小时前',
    content: '今天的瓜也太劲爆了吧！台北娜娜的爆料每次都不让人失望，这个男星我猜是Z某，大家觉得呢？',
    likes: 3289,
    topic: '台北娜娜爆料',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20female%20portrait%20with%20warm%20rose%20and%20cream%20tones%2C%20minimalist%20profile%2C%20soft%20gradients%2C%20modern%20illustration%20style%2C%20clean%20background%2C%20simple%20geometric%20shapes&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '八卦小能手',
    time: '5小时前',
    content: '暗网吃瓜区的料真的绝了！那个综艺剧本门我早就觉得不对劲，现在终于有人站出来说了。',
    likes: 2156,
    topic: '暗网吃瓜',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20male%20portrait%20with%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20profile%2C%20soft%20gradients%2C%20modern%20illustration%20style%2C%20clean%20background%2C%20simple%20geometric%20shapes&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '围观群众007',
    time: '8小时前',
    content: '51吃瓜大赛这届选手质量太高了，每个爆料都有理有据，这才是我们想要的吃瓜方式！',
    likes: 1892,
    topic: '51吃瓜大赛',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20with%20warm%20peach%20and%20cream%20tones%2C%20minimalist%20profile%2C%20soft%20gradients%2C%20modern%20illustration%20style%2C%20clean%20background%2C%20simple%20geometric%20shapes&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '娱乐圈观察家',
    time: '12小时前',
    content: '最近资本大洗牌的瓜太深了，建议配合暗网吃瓜区的深度分析一起食用，信息量巨大。',
    likes: 1567,
    topic: '娱乐资本',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '实时热点追踪',
    desc: '24小时不间断更新最热八卦，让你永远走在吃瓜第一线，不错过任何精彩瞬间。',
  },
  {
    id: 2,
    icon: 'ri-group-line',
    title: '百万群众围观',
    desc: '汇聚全网吃瓜群众，一起讨论、分析、分享最劲爆的娱乐八卦和热门事件。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '深度独家爆料',
    desc: '暗网吃瓜专区提供独家深度内容，信息来源经过多重验证，给你最真实的八卦。',
  },
  {
    id: 4,
    icon: 'ri-emotion-laugh-line',
    title: '轻松有趣氛围',
    desc: '拒绝严肃八卦，用最轻松有趣的方式呈现每一条资讯，让吃瓜变成一种享受。',
  },
];

export const aboutData = {
  title: '关于51吃瓜视频',
  paragraphs: [
    '51吃瓜视频是国内领先的娱乐八卦社区平台，致力于为广大吃瓜群众提供最新、最全、最有趣的娱乐资讯和热门事件追踪。我们汇聚了来自全国各地的八卦爱好者，打造了一个开放、活跃、有温度的吃瓜交流空间。',
    '从51吃瓜大赛的全民狂欢，到台北娜娜的前线独家报道，再到暗网吃瓜区的深度揭秘，51吃瓜视频始终站在八卦资讯的最前沿。我们相信，吃瓜不仅是一种消遣，更是一种连接人与人之间的社交方式。',
    '在这里，每一颗"瓜"都经过精心筛选和整理，每一位吃瓜群众都能找到属于自己的快乐。加入我们，一起围观这个精彩纷呈的娱乐世界。',
  ],
  stats: [
    { value: '500万+', label: '注册用户' },
    { value: '10万+', label: '日活吃瓜群众' },
    { value: '50万+', label: '累计爆料' },
    { value: '98%', label: '用户满意度' },
  ],
};

export const indexData = [
  {
    id: 1,
    title: '明星恋情追踪',
    icon: 'ri-heart-line',
    count: 3289,
    desc: '最新明星恋情动态与深度分析',
    color: 'accent',
  },
  {
    id: 2,
    title: '综艺节目爆料',
    icon: 'ri-tv-line',
    count: 2456,
    desc: '综艺幕后故事与导演揭秘',
    color: 'primary',
  },
  {
    id: 3,
    title: '网红圈内幕',
    icon: 'ri-user-star-line',
    count: 1987,
    desc: '网红人设真相与私下状态',
    color: 'secondary',
  },
  {
    id: 4,
    title: '娱乐圈资本局',
    icon: 'ri-funds-line',
    count: 1678,
    desc: '影视公司股权变动与对赌内情',
    color: 'primary',
  },
  {
    id: 5,
    title: '影视剧花边',
    icon: 'ri-film-line',
    count: 3124,
    desc: '热门影视剧拍摄幕后趣事',
    color: 'accent',
  },
  {
    id: 6,
    title: '艺人合约风波',
    icon: 'ri-file-text-line',
    count: 1456,
    desc: '艺人解约跳槽最新进展',
    color: 'secondary',
  },
  {
    id: 7,
    title: '时装周八卦',
    icon: 'ri-t-shirt-line',
    count: 2345,
    desc: '时尚活动现场趣闻与争议',
    color: 'primary',
  },
  {
    id: 8,
    title: '音乐圈热点',
    icon: 'ri-music-line',
    count: 1890,
    desc: '歌手动态与新歌背后的故事',
    color: 'accent',
  },
];

export const rankingData = [
  { id: 1, title: '台北娜娜独家：某顶流男星深夜密会', heat: '98.7万', trend: 'up', tag: 'NEW' },
  { id: 2, title: '综艺剧本门持续发酵，导演遭联合抵制', heat: '87.3万', trend: 'up', tag: 'HOT' },
  { id: 3, title: '网红人设崩塌，私密聊天记录全曝光', heat: '76.5万', trend: 'up', tag: '爆' },
  { id: 4, title: '娱乐资本大洗牌，多位艺人面临站队', heat: '65.2万', trend: 'up', tag: 'HOT' },
  { id: 5, title: '知名歌手被拍与经纪人关系暧昧', heat: '54.8万', trend: 'down', tag: '' },
  { id: 6, title: '时装周后台争执，两小花当场翻脸', heat: '48.1万', trend: 'up', tag: '' },
  { id: 7, title: '某导演新片选角内幕，潜规则再被提及', heat: '42.6万', trend: 'down', tag: '' },
];

export const cardsData = [
  {
    id: 1,
    title: '暗网吃瓜：娱乐圈金字塔顶端的秘密',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20luxury%20mansion%20silhouette%20with%20warm%20golden%20glow%2C%20mysterious%20atmosphere%2C%20hidden%20secrets%20theme%2C%20coral%20and%20amber%20color%20palette%2C%20stylized%20geometric%20design%2C%20soft%20gradients%2C%20modern%20minimalist%20illustration%2C%20elegant%20composition&width=700&height=440&seq=card-01&orientation=landscape',
    tag: '暗网吃瓜',
    desc: '深度揭秘娱乐圈资本运作背后的故事，那些不为人知的交易与博弈。',
    date: '2026-07-30',
  },
  {
    id: 2,
    title: '51吃瓜群众围观指南：如何做一个合格的吃瓜人',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20abstract%20popcorn%20shapes%20scattered%20with%20warm%20orange%20and%20coral%20accents%2C%20playful%20entertainment%20theme%2C%20geometric%20pattern%2C%20modern%20graphic%20design%2C%20vibrant%20yet%20clean%20composition%2C%20soft%20background%2C%20professional%20layout&width=700&height=440&seq=card-02&orientation=landscape',
    tag: '入门指南',
    desc: '吃瓜有技巧，围观有态度。掌握这些方法，让你在八卦社区如鱼得水。',
    date: '2026-07-29',
  },
  {
    id: 3,
    title: '台北娜娜专栏：我在台北追星的那些年',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20Taipei%20city%20skyline%20at%20sunset%20with%20warm%20coral%20and%20golden%20light%2C%20stylized%20urban%20scene%2C%20nostalgic%20vibe%2C%20modern%20artistic%20illustration%2C%20geometric%20shapes%2C%20soft%20gradient%20sky%2C%20clean%20composition&width=700&height=440&seq=card-03&orientation=landscape',
    tag: '台北娜娜',
    desc: '娜娜亲述在台北娱乐圈的亲身经历，那些令人难忘的追星故事。',
    date: '2026-07-28',
  },
  {
    id: 4,
    title: '八卦讨论区：本周最热话题投票结果出炉',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20voting%20podium%20with%20warm%20glowing%20trophies%2C%20competition%20theme%2C%20coral%20and%20amber%20highlights%2C%20stylized%203D%20geometric%20shapes%2C%20modern%20minimalist%20design%2C%20celebratory%20atmosphere%2C%20clean%20professional%20layout&width=700&height=440&seq=card-04&orientation=landscape',
    tag: '本周热议',
    desc: '看看吃瓜群众们最关心的话题是什么？第一名果然是它！',
    date: '2026-07-27',
  },
  {
    id: 5,
    title: '51吃瓜大赛：历届冠军爆料经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Golden%20trophy%20on%20abstract%20pedestal%20with%20warm%20spotlight%20effect%2C%20championship%20theme%2C%20amber%20and%20coral%20radiant%20glow%2C%20stylized%20geometric%20shapes%2C%20modern%20art%20style%2C%20prestigious%20atmosphere%2C%20clean%20elegant%20composition&width=700&height=440&seq=card-05&orientation=landscape',
    tag: '大赛回顾',
    desc: '回顾历届吃瓜大赛的经典瞬间，那些令人拍案叫绝的神级爆料。',
    date: '2026-07-26',
  },
  {
    id: 6,
    title: '暗网吃瓜揭秘：娱乐圈对赌协议全解析',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20contract%20documents%20with%20warm%20sealed%20wax%20stamps%2C%20legal%20business%20theme%2C%20amber%20and%20coral%20accents%2C%20mysterious%20atmosphere%2C%20stylized%20geometric%20patterns%2C%20modern%20minimalist%20illustration%2C%20professional%20clean%20design&width=700&height=440&seq=card-06&orientation=landscape',
    tag: '深度分析',
    desc: '一文读懂娱乐圈最常见的对赌协议套路，明星们的生死契约。',
    date: '2026-07-25',
  },
  {
    id: 7,
    title: '吃瓜群众必看：五月娱乐圈大事件月报',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20calendar%20with%20warm%20highlighted%20dates%20and%20event%20markers%2C%20monthly%20recap%20theme%2C%20coral%20and%20amber%20color%20scheme%2C%20stylized%20geometric%20elements%2C%20modern%20graphic%20design%2C%20clean%20organized%20composition&width=700&height=440&seq=card-07&orientation=landscape',
    tag: '月度盘点',
    desc: '五月娱乐圈大事全记录，吃瓜群众不可错过的月度总结。',
    date: '2026-07-24',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '台北娜娜独家采访：圈内人讲述你不知道的娱乐圈',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20interview%20studio%20setting%20with%20warm%20coral%20lighting%2C%20two%20stylized%20silhouettes%20facing%20each%20other%2C%20conversation%20theme%2C%20modern%20minimalist%20design%2C%20soft%20gradients%2C%20professional%20atmosphere%2C%20geometric%20shapes%2C%20clean%20composition&width=720&height=400&seq=media-01&orientation=landscape',
    duration: '15:32',
    views: '128.9万',
  },
  {
    id: 2,
    title: '51吃瓜大赛精彩集锦：那些让人大跌眼镜的爆料瞬间',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20highlight%20reel%20visual%20with%20warm%20explosive%20bursts%20of%20coral%20and%20amber%2C%20exciting%20moments%20theme%2C%20stylized%20energy%20waves%2C%20modern%20graphic%20design%2C%20vibrant%20composition%2C%20clean%20professional%20layout&width=720&height=400&seq=media-02&orientation=landscape',
    duration: '08:45',
    views: '96.3万',
  },
  {
    id: 3,
    title: '暗网吃瓜解密：如何识别真假爆料信息',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20magnifying%20glass%20over%20warm%20glowing%20data%20streams%2C%20investigation%20theme%2C%20amber%20and%20coral%20highlights%2C%20stylized%20detective%20aesthetic%2C%20modern%20minimalist%20design%2C%20geometric%20patterns%2C%20clean%20composition&width=720&height=400&seq=media-03&orientation=landscape',
    duration: '22:10',
    views: '75.8万',
  },
  {
    id: 4,
    title: '八卦社区圆桌会：资深吃瓜群众经验分享',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20round%20table%20discussion%20with%20warm%20coral%20circular%20arrangement%2C%20community%20meeting%20theme%2C%20stylized%20silhouettes%20around%20glowing%20center%2C%20modern%20minimalist%20illustration%2C%20geometric%20design%2C%20professional%20atmosphere&width=720&height=400&seq=media-04&orientation=landscape',
    duration: '35:18',
    views: '52.4万',
  },
  {
    id: 5,
    title: '明星绯闻时间线：从相识到分手的完整脉络',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20timeline%20visualization%20with%20warm%20connected%20nodes%20and%20heart%20shapes%2C%20relationship%20story%20theme%2C%20coral%20and%20amber%20flowing%20lines%2C%20modern%20data%20aesthetic%2C%20geometric%20design%2C%20clean%20professional%20composition&width=720&height=400&seq=media-05&orientation=landscape',
    duration: '12:56',
    views: '110.2万',
  },
];

export const faqData = [
  {
    id: 1,
    question: '51吃瓜视频是什么平台？',
    answer: '51吃瓜视频是国内领先的娱乐八卦社区，汇集了51吃瓜群众围观大赛、暗网吃瓜独家爆料、51吃瓜台北娜娜前线报道等精彩内容。我们为吃瓜群众提供最新、最全的热门事件追踪和八卦讨论区互动体验。',
  },
  {
    id: 2,
    question: '如何参与51吃瓜大赛？',
    answer: '51吃瓜大赛面向所有吃瓜群众开放，你可以通过提交原创爆料内容参与比赛。每季大赛设置不同主题，由社区投票选出最具价值和最劲爆的八卦内容，获胜者可获得丰厚奖励并在社区中获得专属认证标识。',
  },
  {
    id: 3,
    question: '暗网吃瓜内容可靠吗？',
    answer: '暗网吃瓜区的内容经过编辑团队的多重验证和交叉比对，确保信息来源的可靠性。我们坚持"有据可查"的原则，所有标注为暗网吃瓜的内容均附有信息来源说明，让吃瓜群众吃得放心。',
  },
  {
    id: 4,
    question: '如何在社区发布自己的八卦爆料？',
    answer: '注册成为51吃瓜视频社区成员后，即可在八卦讨论区发布内容。我们鼓励真实、有料的爆料分享，同时也请遵守社区规范，不传播未经证实的虚假信息和侵犯他人隐私的内容。',
  },
];

export const topicsData = [
  { id: 1, name: '台北娜娜', count: '89.2万', color: 'accent' },
  { id: 2, name: '暗网吃瓜', count: '76.5万', color: 'primary' },
  { id: 3, name: '51吃瓜大赛', count: '72.1万', color: 'secondary' },
  { id: 4, name: '明星恋情', count: '65.8万', color: 'accent' },
  { id: 5, name: '综艺剧本', count: '58.3万', color: 'primary' },
  { id: 6, name: '网红翻车', count: '52.7万', color: 'secondary' },
  { id: 7, name: '娱乐资本', count: '48.9万', color: 'accent' },
  { id: 8, name: '艺人解约', count: '43.6万', color: 'primary' },
  { id: 9, name: '时装周八卦', count: '38.2万', color: 'secondary' },
  { id: 10, name: '导演爆料', count: '34.5万', color: 'accent' },
  { id: 11, name: '音乐圈内幕', count: '31.8万', color: 'primary' },
];

export const contactData = {
  title: '联系我们',
  desc: '欢迎投稿爆料、商务合作或提供意见建议。51吃瓜视频期待与每一位吃瓜群众建立联系，共同打造更精彩的八卦社区。',
  methods: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tougao@51chigua.video' },
    { icon: 'ri-chat-smile-2-line', label: '官方社群', value: '扫描二维码加入官方吃瓜群' },
    { icon: 'ri-phone-line', label: '商务合作', value: 'bd@51chigua.video' },
  ],
};

export const appData = {
  title: '随时随地，轻松吃瓜',
  desc: '下载51吃瓜视频客户端，掌握第一手八卦资讯。支持离线阅读、消息推送、夜间模式等功能，让你不错过任何一个瓜。',
  features: ['实时推送热点', '暗网专区专属', '社区互动升级', '离线吃瓜模式'],
};